import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

/**
 * A minimum for a template-driven numeric field.
 *
 * Angular's own `min` validator directive arrived in v12, so on this version `[min]` sets the DOM
 * attribute and registers nothing: the form stays valid and a submit button gated on it stays
 * enabled. This registers an actual validator, so a value under the minimum blocks the form and can
 * be reported beside the field.
 */
@Directive({
  selector: '[appMinValue][ngModel]',
  providers: [{ provide: NG_VALIDATORS, useExisting: MinValueDirective, multi: true }]
})
export class MinValueDirective implements Validator {

  @Input('appMinValue') minValue: number;

  validate(control: AbstractControl): ValidationErrors | null {
    if (this.minValue == null) {
      return null;
    }

    const value = control.value;

    // An empty field is the required validator's business, not this one's.
    if (value === null || value === undefined || value === '') {
      return null;
    }

    const numeric = Number(value);

    if (isNaN(numeric) || numeric >= this.minValue) {
      return null;
    }

    return { appMinValue: { min: this.minValue, actual: numeric } };
  }
}
